export default __webpack_public_path__ + "static/media/3-instru.f724d6b1.png";